"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var youtubeTheme = {
  tenant: {
    primary: "#ff0400"
  }
};
var _default = exports["default"] = youtubeTheme;